export enum TicketTypeEnum {
  BackOrder = 'back_order',
  Local = 'local_application',
  Connection = 'connection',
  Moving = 'moving',
  GlobalProblem = 'global_problem',
}
